// src/reducers/priceReducer.js

import { types } from '../types/types';

const initialState = {
    editingPrice: {
        id: 0,
        realmFk: '',
        validFrom: '',
        validUntil: '',
        amount: 0,
        productFk: 0,
        zone: 0,
        measurementUnit: '',
        status: true,
        type: 0
    }
};

export const priceReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.editingPriceInfo:
            return {
                ...state,
                editingPrice: action.payload
            };

        case types.clearPriceInfo:
            return {
                ...state,
                editingPrice: initialState.editingPrice
            };

        default:
            return state;
    }
};